import { render, staticRenderFns } from "./WaitingFor.vue?vue&type=template&id=1f9a5a56"
import script from "./WaitingFor.vue?vue&type=script&lang=ts"
export * from "./WaitingFor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports